import { Link } from 'wouter';
import { Card, PageHeader } from '@/components/AppShell';

export function NotFoundPage() {
  return (
    <div>
      <PageHeader title="页面不存在" />
      <Card className="space-y-3 text-sm">
        <p>您访问的页面可能已被移动或暂未开放。</p>
        <Link className="text-primary underline-offset-2 hover:underline" href="/">
          返回首页
        </Link>
      </Card>
    </div>
  );
}
